export { default } from './ContentExpansionPanel';
